import React, { useMemo } from 'react';
import { format } from 'date-fns';

import { shortDateTimeFormat } from '@crm-package/app';

import { INotificationGridItem } from '../notification-grid';

import { DetailsRow } from './DetailsRow';
import { getDealsIdComponent } from './utils';

export const ExpiringDealsDetails: React.FC<INotificationGridItem> = ({
  notificationDetails,
}) => {
  const { dealsCount, leadsCount, dateFrom, dateTo, dealIds } =
    notificationDetails.data;
  const validDateFrom = format(new Date(dateFrom), shortDateTimeFormat);
  const validDateTo = format(new Date(dateTo), shortDateTimeFormat);
  const DealsIdComponent = useMemo(
    () => getDealsIdComponent(dealIds),
    [dealIds]
  );

  return (
    <>
      <DetailsRow label="Deals count" value={dealsCount} />
      <DetailsRow label="Leads count" value={leadsCount} />
      <DetailsRow label="Valid date from" value={validDateFrom} />
      <DetailsRow label="Valid date to" value={validDateTo} />
      <DetailsRow label="Deals IDs" component={DealsIdComponent} />
    </>
  );
};
